import React from "react";
import { useState } from "react";
import { convertArrayToCSV } from "convert-array-to-csv";
import FileSaver from "file-saver";
import "../Dashboard/Dashboard.css";
import Select from "react-select";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { useSelector } from "react-redux/es/exports";
import { AskpageNumber } from "../Model/AskpageNumber";
import Pagination from "../../utils/Pagination";
import axiosinstances from "../../Helper/useAxios";
import { v4 as uuid } from "uuid";
import { isSuperAdmin, isUserAdmin, requestLoading, stylesofStype } from "../../utils/comman/Common";
import { ShowAllDetails } from "../Model/ShowAllDetails";
import { setpageContent } from "../../utils/Constant";
const OTTRecharge = () => {
  const requesterId = useSelector((state) => state.selectedretailerReqesterReducer.requesterId);
  const [axiosInstance] = axiosinstances();
  const selectedId = useSelector((state) => state.selectedRetailerReducer.id);
  //console.log("selectedId", selectedId);
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  const [statusOption, setStatusOption] = useState([
    { value: "SUCCESS", label: "SUCCESS" },
    { value: "ACCEPTED", label: "ACCEPTED" },
    { value: "PENDING", label: "PENDING" },
    { value: "INTERNAL_FAILURE", label: "INTERNAL_FAILURE" },
    { value: "PROCESSING", label: "PROCESSING" },
    { value: "HUNG", label: "HUNG" },
    { value: "FAILED", label: "FAILED" },
    { value: "AUTO_REVERSED", label: "AUTO_REVERSED" },
    { value: "MANUALLY_REVERSED", label: "MANUALLY_REVERSED" },
    { value: "SUCCESS_TO_FAILED", label: "SUCCESS_TO_FAILED" },
  ]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [isExportable, setIsExportable] = useState(false);
  const [finalSelectedStatus, setFinalSelectedStatus] = useState();
  const [showModal, setShowModel] = useState(false);
  const [firstSelectedPage, setFirstSelectedPage] = useState();
  const [secondSelectedPage, setSecondSelectedPage] = useState();
  const [search, setsearch] = useState("");
  const [searchTyping, setSearchTyping] = useState(false);
  const [formDate, setFormDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [updatedFormDate, setUpdatedFormDate] = useState("");
  const [updatedToDate, setUpdatedToDate] = useState("");
  const [selectOption, setSelectOption] = useState("");
  const [pageStart, setpageStart] = useState(0);
  const [pagelimit, setPagelimit] = useState(0);
  const [customPage, setCustomPage] = useState("");
  const [paginationDetails, setPaginationDetails] = useState({
    currentPage: 1,
    postsPerPage: 20,
    totalPost: 0,
    totalPages: 0,
  });
  const [loading, setLoading] = useState(false);
  const [table, settable] = useState([]);
  const [isclearClicked, setIsclearClicked] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [selectedDataToShow, setSelectedDataToShow] = useState({})
  const [showModalDetails, setShowModelDetails] = useState(false);

  useEffect(() => {
    if (Array.isArray(selectedStatus) && selectedStatus.length > 0) {
      const values = selectedStatus.map((val) => val.value);
      setFinalSelectedStatus(values);
    } else if (Array.isArray(selectedStatus) && selectedStatus.length === 0) {
      setFinalSelectedStatus([]);
    }
  }, [selectedStatus]);
  useEffect(() => {
    if (selectOption === "All" && firstSelectedPage !== undefined) {
      setpageStart(1);
      setPagelimit(firstSelectedPage);
    } else if (
      selectOption == "Custom" &&
      firstSelectedPage !== undefined &&
      secondSelectedPage !== undefined
    ) {
      setpageStart(firstSelectedPage);
      setPagelimit(secondSelectedPage);
    }
  }, [selectOption, firstSelectedPage, secondSelectedPage]);
  //console.log("finalSelectedStatus", finalSelectedStatus);
  const Transactiontable = useSelector(
    (state) => state.transactionhistoryreducer.Transaction
  );
  const a = useSelector((state) => state.transactionhistoryreducer.Transaction);
  const responseobject = useSelector(
    (state) => state.getclaimdatareducer.getclaimdata
  );

  useEffect(() => {
    if (id && isUserAdmin(id)) {
      //console.log("bbbbbb");
      fetchpagedata(0, id, isUserAdmin(id), selectedId);
    } else if (id && !isUserAdmin(id)) {
      fetchpagedata(0, id, isUserAdmin(id), selectedId);
    }
  }, [id, selectedId]);

  const [pageindex, setpageindex] = useState("");

  const handalpageclick = async (index) => {
    setPaginationDetails((prev) => {
      return { ...prev, currentPage: index };
    });
    setpageindex(index);
    setpageindex((ind) => {
      return ind;
    });
    if (isUserAdmin(id) && selectedId !== null) {
      fetchpagedata(index - 1, id, isUserAdmin(id), selectedId);
    } else {
      fetchpagedata(index - 1, id, isUserAdmin(id));
    }
  };
  const totalpage = paginationDetails.totalPages;
  //console.log("paginationDetails", paginationDetails);
  const d =
    sessionStorage.getItem("token") &&
    JSON.parse(sessionStorage.getItem("token")).token
      ? JSON.parse(sessionStorage.getItem("token")).token
      : "";
  const e = JSON.parse(sessionStorage.getItem("token"));

  const searchdata = async () => {
    setsearch((search) => {
      return search;
    });
    const callingsearchapi = await searchapidata(search, id);
    settable(() => callingsearchapi.orders);
  };
  const fetchpagedata = async (pageindex, id, isAdmin, selectedId) => {
    setDataLoading(true);
    setsearch("");
    const response = await axiosInstance
      .post(
        `/api/v1/ott/order/history`,
        {
          header: {
            "client-id": id, // client id will admin id
            role: "ROLE_RETAILER_FINXPAY",
            "msgType" :"ORDER_HISTORY",
            "channel" :"ADMIN",
            "requesterId" : requesterId,
            "requestId" : uuid(),
            "time" : new Date()
          },
          device: null,
          agentId: isAdmin ? selectedId : id,
          pageNo: pageindex,
          startDate: formDate,
          endDate: toDate,
          status:
            finalSelectedStatus !== undefined &&
            finalSelectedStatus.length !== 0
              ? finalSelectedStatus
              : null,
        },
        {
          headers: {
            Authorization: `Bearer ${e}`,
            "client-id": id,
            role: "ROLE_RETAILER_FINXPAY",
            
          },
        }
      )
      .then((res) => {
        //console.log("res", res);
        settable(res.data.orders);
        //return res
        setDataLoading(false);
        setPaginationDetails((prev) => {
          return {
            ...prev,
            totalPost: res.data?.totalElements,
            totalPages: res.data?.totalPages,
          };
        });
        setIsDataLoaded(true);
      })
      .catch((err) => {
        //console.log(err);
        setDataLoading(false);
        setIsDataLoaded(false);
        toast.error("Something went wrong");
      });

    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };

  const searchapidata = async (search, id) => {
    const trimSearch = search.trim()
    setDataLoading(true);
    const response = await axiosInstance
      .get(`/api/v1/ott/order/search/${trimSearch}`, {
        headers: {
          Authorization: `Bearer ${e}`,
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
          
        },
      })
      .then((res) => {
        setDataLoading(false);
        return res;
      })
      .catch((err) => {
        //console.log(err);
        setDataLoading(false);
        toast.error("Something went wrong");
      });
    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };

  const fetchpagedataInloop = async (
    pageindex,
    id,
    isAdmin,
    finalSelectedStatus
  ) => {
    const response = await axiosInstance
      .post(
        `/api/v1/ott/order/history`,
        {
          header: {
            "client-id": id,
            role: "ROLE_RETAILER_FINXPAY",
            "msgType" :"ORDER_HISTORY",
            "channel" :"ADMIN",
            "requesterId" : requesterId,
            "time" : new Date()
          },
          device: null,
          agentId: isAdmin ? selectedId : id,
          pageNo: pageindex,
          startDate: formDate,
          endDate: toDate,
          status:
            finalSelectedStatus !== undefined &&
            finalSelectedStatus.length !== 0
              ? finalSelectedStatus
              : null,
        },
        {
          headers: {
            Authorization: `Bearer ${e}`,
            "client-id": id,
            role: "ROLE_RETAILER_FINXPAY",
          },
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        //console.log(err);
        toast.error("Something went wrong");
      });

    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };

  const enterTxnsearch = (event) => {
    event.preventDefault();
    setsearch(event.target.value);
    setSearchTyping(true);
  };

 

  const onExportData = () => {
    setShowModel(true);
  };

  const closePopUp = () => {
    setShowModel(false);
    setFirstSelectedPage();
    setSecondSelectedPage();
    setCustomPage("");
    setSelectOption("");
  };
  //console.log("formDate", formDate);
  async function exportAllFile() {
    setLoading(true);
    let result = [];
    //console.log("limit", pageStart, pagelimit);
    for (let i = pageStart - 1; i < pagelimit; i++) {
      const data = await fetchpagedataInloop(
        i,
        id,
        isUserAdmin(id),
        finalSelectedStatus
      );
      //console.log("data", data);
      if (Array.isArray(data?.orders)) {
        const unwantedHeaderForExcel = data.orders.map((val) => {
          // val.CONSUMER_NUM = val.optional.CONSUMER_NUM
          val.notes =
            val.notes !== null && val.notes !== undefined ? val.notes[0] : "";
          val.operator = val.transaction.operator;
          val.amount = val.transaction.amount;
          delete val.transaction;
          delete val.supplierId;
          delete val.statusChangeLog;
          delete val.supplierUrl;
          delete val.supplierOrderId;
          delete val.paymentRefId;

          delete val.paymentTxnId;
          delete val.paymentStatus;
          delete val.walletBalance;

          delete val.walletCreditLimit;
          delete val.walletLien;
          //  val={...val, ...val.optional}
          val.CONSUMER_NUM = val.optional.CONSUMER_NUM;
          val.category = val.optional.category;
          delete val.optional;
          const newvalues = val;
          return newvalues;
        });
        result.push(...unwantedHeaderForExcel);
      }
    }

    const csv = convertArrayToCSV(result);
    const csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    FileSaver.saveAs(csvData, "data.csv");
    closePopUp();
    setLoading(false);
  }
  const callApi = () => {
    if (isUserAdmin(id) && selectedId !== null) {
      fetchpagedata(0, id, isUserAdmin(id), selectedId);
    } else {
      fetchpagedata(0, id, isUserAdmin(id));
    }
  };
  const txnFromDateHandler = (e) => {
    setFormDate(e.target.value);
  };
  const txnToDateHandler = (e) => {
    setToDate(e.target.value);
  };
  const updatedFromDateHandler = (e) => {
    setUpdatedFormDate(e.target.value);
  };
  const updatedToDateHandler = (e) => {
    setUpdatedToDate(e.target.value);
  };
  const reverse = ["AUTO_REVERSED", "MANUALLY_REVERSED"];
  const callApiReversalRepoertApi = (e) => {
    e.preventDefault();
    setLoading(true);
    if (isUserAdmin(id) && selectedId !== null) {
      exportReversalReport(0, id, isUserAdmin(id), reverse);
    } else {
      exportReversalReport(0, id, isUserAdmin(id), reverse);
    }
  };
  async function exportReversalReport(
    pageindex,
    id,
    isAdmin,
    finalSelectedStatus
  ) {
    await axiosInstance
      .post(
        `/api/v1/billpay/order/history`,
        {
          header: {
            "client-id": id,
            role: "ROLE_RETAILER_FINXPAY",
            "msgType" :"ORDER_HISTORY",
            "channel" :"ADMIN",
            "requesterId" : requesterId,
            "time" : new Date()
          },
          device: null,
          agentId: isAdmin ? selectedId : id,
          pageNo: pageindex,
          startDate: formDate,
          endDate: toDate,
          status:
            finalSelectedStatus !== undefined &&
            finalSelectedStatus.length !== 0
              ? finalSelectedStatus
              : null,
        },
        {
          headers: {
            Authorization: `Bearer ${e}`,
            "client-id": id,
            role: "ROLE_RETAILER_FINXPAY",
          },
        }
      )
      .then((res) => {
        getExportFile(
          res.data?.totalPages !== undefined ? res.data?.totalPages : 0
        );
      })
      .catch((err) => {
        //console.log(err);
        toast.error("Something went wrong");
        setLoading(false);
      });
  }
  const getExportFile = async (allpagenum) => {
    let result = [];
    for (let i = 0; i < allpagenum; i++) {
      //console.log("index1", i);
      const data = await fetchpagedataInloop(i, id, isUserAdmin(id), reverse);
      if (Array.isArray(data?.orders)) {
        const unwantedHeaderForExcel = data.orders
          .filter((values) => {
            const updatedon = new Date(values.updatedOn);
            const newfromDate = new Date(updatedFormDate);
            const newToDate = new Date(updatedToDate);
            return updatedon > newfromDate && updatedon < newToDate;
          })
          .map((val) => {
            val.notes =
              val.notes !== null && val.notes !== undefined ? val.notes[0] : "";
            val.operator = val.transaction.operator;
            val.amount = val.transaction.amount;
            delete val.transaction;
            delete val.supplierId;
            delete val.statusChangeLog;
            delete val.supplierUrl;
            delete val.supplierOrderId;
            delete val.paymentRefId;

            delete val.paymentTxnId;
            delete val.paymentStatus;
            delete val.walletBalance;

            delete val.walletCreditLimit;
            delete val.walletLien;
            //  val={...val, ...val.optional}
            val.CONSUMER_NUM = val.optional.CONSUMER_NUM;
            val.category = val.optional.category;
            delete val.optional;
            const newvalues = val;
            return newvalues;
          });
        result.push(...unwantedHeaderForExcel);
      }
    }

    const csv = convertArrayToCSV(result);
    const csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    FileSaver.saveAs(csvData, "data.csv");
    closePopUp();
    setLoading(false);
  };
  const clearSearch = () => {
    setsearch("");
    setSearchTyping(false);
    callApi();
  };
  const applyStatus = (e) => {
    e.preventDefault();
    setIsExportable(true);
    callApi();
  };
  //console.log("finalSelectedStatus", finalSelectedStatus);
  useEffect(() => {
    if (
      finalSelectedStatus !== undefined &&
      finalSelectedStatus.length == 0 &&
      isclearClicked
    ) {
      callApi();
    }
  }, [finalSelectedStatus, isclearClicked]);
  const resetApply = () => {
    setFinalSelectedStatus([]);
    setSelectedStatus([]);
    setIsExportable(false);
    setFormDate("");
    setToDate("");
    setIsclearClicked(true);
  };
  const fromDateHandler = (e) => {
    setFormDate(e.target.value);
  };
  const toDateHandler = (e) => {
    setToDate(e.target.value);
  };
  const changeHandler = (select) => {
    setSelectedStatus(select);
  };
  const revcheckDisable = () => {
    let disabled = true;
    if (
      formDate !== "" &&
      toDate !== "" &&
      updatedFormDate !== "" &&
      updatedToDate !== ""
    ) {
      disabled = false;
    }
    return disabled;
  };
  const checkDisable = () => {
    let disabled = true;
    if (finalSelectedStatus !== undefined && finalSelectedStatus.length > 0) {
      disabled = false;
    } else if (formDate !== "") {
      disabled = false;
    } else if (toDate !== "") {
      disabled = false;
    }
    return disabled;
  };
  const showAllData = (data) =>{
    setSelectedDataToShow({...data})
    setShowModelDetails(true)
  }
  const closeDetailsPopUp = () => {
    setShowModelDetails(false);
  };
  return (
    <React.Fragment>
      {loading ? (
        requestLoading()
      ) : (
        <>
          <AskpageNumber
            showModal={showModal}
            closePopUp={closePopUp}
            totalpage={totalpage}
            setFirstSelectedPage={setFirstSelectedPage}
            firstSelectedPage={firstSelectedPage}
            exportAllFile={exportAllFile}
            secondSelectedPage={secondSelectedPage}
            setSecondSelectedPage={setSecondSelectedPage}
            selectOption={selectOption}
            setSelectOption={setSelectOption}
            customPage={customPage}
            setCustomPage={setCustomPage}
          />
          <ShowAllDetails
           showModal={showModalDetails}
           closePopUp={closeDetailsPopUp}
           data={selectedDataToShow}
         />
          <div class="mid">
            <div class="container-fluid">
              <div class="maincard">
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                  <button
                    class="nav-link active"
                    id="mobile-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-mobi"
                    type="button"
                    role="tab"
                    aria-controls="nav-mobi"
                    aria-selected="true"
                  >
                    OTT Transactions
                  </button>
                </div>

                <div class="tab-content" id="mobiletab">
                  <div
                    class="tab-pane fade show active"
                    id="nav-mobi"
                    role="tabpanel"
                    aria-labelledby="mobile-tab"
                  >
                    <div class="head">
                      {/* <h3>OTT History</h3> */}
                      
                      <div class="dropdown fltr">
                        <button
                          type="button"
                          title="Filter"
                          class="filter dropdown-toggle"
                          id="fillist"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="false"
                          aria-expanded="false"
                          // style={{border:'2px solid rgb(132, 133, 135)'}}
                        >
                          Filter
                        </button>
                        <div
                          class="dropdown-menu dropdown-menu-end"
                          aria-labelledby="fillist"
                        >
                          <form onSubmit={applyStatus}>
                            <div className="col-12 col-md-12 mb-2 border-bottom ">
                              <div class="form-floating">
                                <div className="formselect mb-2">
                                  <label>Selected Status</label>
                                  <Select
                                    className="basic-multi-select"
                                    styles={stylesofStype}
                                    closeMenuOnSelect={false}
                                    components={{
                                      IndicatorsContainer: () => null,
                                      IndicatorSeparator: () => null,
                                    }}
                                    isMulti
                                    options={statusOption}
                                    onChange={changeHandler}
                                    value={selectedStatus}
                                    placeholder=" select multiple option"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="filters">
                              <label for="select-state">From Date:</label>
                              <input
                                type="date"
                                onChange={fromDateHandler}
                                value={formDate}
                              />
                            </div>

                            <div class="filters">
                              <label for="select-state">To Date:</label>
                              <input
                                min={formDate}
                                type="date"
                                onChange={toDateHandler}
                                value={toDate}
                              />
                            </div>

                            <div class="fbtn">
                              <button
                                class="btn"
                                type="submit"
                                id="btna"
                                disabled={checkDisable()}
                              >
                                Apply
                              </button>
                              <button
                                class="btn"
                                type="reset"
                                id="btnc"
                                onClick={resetApply}
                              >
                                Clear
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                      <div class="headsearch">
                        <div class="input-group">
                          <input
                            type="text"
                            class="form-control"
                            onChange={(event) => enterTxnsearch(event)}
                            placeholder="Search transaction..."
                            value={search}
                          />
                          <button
                            class="btn search"
                            disabled={search.length <= 3}
                            type="button"
                            id="txnsrch"
                            onClick={searchdata}
                          >
                            search
                          </button>
                          <button
                            style={{ background: "#FF8D33", marginLeft: "3px" }}
                            class="btn delete"
                            // disabled={search.length <= 3}
                            type="button"
                            onClick={clearSearch}
                          >
                            clear
                          </button>
                        </div>
                      </div>
                      <div class="dropdown fltr mr-2">
                        <button
                          type="button"
                          title="Revesal Report"
                          class="filter dropdown-toggle"
                          id="fillist"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="false"
                          aria-expanded="false"
                          style={{border:'2px solid rgb(14, 14, 14)'}}
                        >
                          Filter
                        </button>
                        <div
                          class="dropdown-menu dropdown-menu-end"
                          id="filterbox"
                          aria-labelledby="fillist"
                        >
                          <form onSubmit={callApiReversalRepoertApi}>
                            <div class="filters">
                              <label for="select-state">TXN From Date:</label>
                              <input
                                type="date"
                                onChange={txnFromDateHandler}
                                value={formDate}
                              />
                            </div>

                            <div class="filters">
                              <label for="select-state">TXN To Date:</label>
                              <input
                                min={formDate}
                                type="date"
                                onChange={txnToDateHandler}
                                value={toDate}
                              />
                            </div>
                            <div class="filters">
                              <label for="select-state">
                                Updated From Date:
                              </label>
                              <input
                                type="date"
                                onChange={updatedFromDateHandler}
                                value={updatedFormDate}
                              />
                            </div>

                            <div class="filters">
                              <label for="select-state">Updated To Date:</label>
                              <input
                                min={formDate}
                                type="date"
                                onChange={updatedToDateHandler}
                                value={updatedToDate}
                              />
                            </div>
                            <div class="fbtn">
                              <button
                                class="btn"
                                id="btnapply"
                                type="submit"
                                disabled={revcheckDisable()}
                              >
                                Download Reversal Report
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                    <div class="txn-list" id="recntxn">
                      {dataLoading ? (
                        <div class="d-flex justify-content-center">
                          <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <>
                          {table !== undefined &&
                          table !== null &&
                          isDataLoaded &&
                          table.length == 0 ? (
                            <h6>No Record Found</h6>
                          ) : table !== undefined &&
                            table == null &&
                            isDataLoaded ? (
                            <h6>No Record Found</h6>
                          ) : (
                            table?.map((data) => {
                              return (
                                <div class="txn-item" key={data.id}>
                                  <div class="txn-head" id="txnhead1">
                                    <div
                                      class="collapsed"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#txn1"
                                      aria-expanded="false"
                                      aria-controls="txn1"
                                    >
                                      <div
                                        class={`txncard ${
                                          data.status === "SUCCESS"
                                            ? "success grbg"
                                            : `${
                                                data.status === "PENDING" ||
                                                data.status === "PROCESSING" ||
                                                data.status === "HUNG" ||
                                                data.status === "ACCEPTED"
                                                  ? "pending ylbg"
                                                  : "failed rdbg"
                                              }`
                                        }`}
                                      >
                                        <div class="row">
                                          <div class={`col-12 ${ ((isSuperAdmin(id) && selectedId == null) || (isUserAdmin(id) && selectedId == null)) ? "col-md-4" : "col-md-5"}`}>
                                            <div class="txntxt">
                                              {/* <li className="bill"> */}
                                              {/* <img src={require('../../assests/images/airtel.png')} alt="logo"/> */}
                                              <h5>
                                                {data.transaction.operator} -{" "}
                                                {data.transaction.mobile}
                                              </h5>
                                              {/* </li> */}
                                            </div>
                                            <div class="txntxt">
                                              <h6>
                                                Transaction ID: {data?.id}
                                              </h6>
                                            </div>
                                          </div>
                                          {/* <div class="col-12 col-sm-5 col-lg-3">
                                  <div class="txntxt">
                                    <h6>Txn ID: {data.requestId}</h6>
                                  </div>
                                </div> */}

                                          <div class="col-12 col-md-4">
                                            <div class="txntxt">
                                              <h6>
                                                Biller TXN ID:{" "}
                                                {data.billerTxnId}
                                              </h6>
                                              { ((isSuperAdmin(id) && selectedId == null) || (isUserAdmin(id) && selectedId == null)) ? 
                                              <h6>
                                              Agent Id:{" "}
                                              {data.agentId}
                                            </h6> :
                                              <h6>
                                                <span>
                                                  {" "}
                                                  {data.createdOn
                                                    .replace("T", " ")
                                                    .slice(0, -4)}{" "}
                                                </span>{" "}
                                              </h6>
                                              }
                                            </div>
                                          </div>
                                          <div class="col-12 col-md-2">
                                            <div class="txntxt">
                                              <h4>
                                                ₹ {data.transaction.amount}{" "}
                                              </h4>
                                              <h4>
                                                {" "}
                                                <span
                                                  class={`${
                                                    data.status === "SUCCESS"
                                                      ? "success"
                                                      : `${
                                                          data.status ===
                                                            "PENDING" ||
                                                          data.status ===
                                                            "PROCESSING" ||
                                                          data.status ===
                                                            "HUNG" ||
                                                          data.status ===
                                                            "ACCEPTED"
                                                            ? "pending"
                                                            : "failed"
                                                        }`
                                                  }`}
                                                >
                                                  {data.status}
                                                </span>
                                              </h4>
                                            </div>
                                          </div>
                                          <div class= {`col-12  ${((isSuperAdmin(id) && selectedId == null) || (isUserAdmin(id) && selectedId == null)) ? "col-md-2" : "col-md-1"} float-right`}>
                                        <div class="txntxt">
                                        {isSuperAdmin(id) &&  <button type="button"  style={{float:'right', backgroundColor:'rgb(159, 166, 178)'}} className="btn dbbtn" onClick={()=>showAllData(data)} ><i class="bi bi-eye-fill"></i> Logs</button>}
                                        { ((isSuperAdmin(id) && selectedId == null) || (isUserAdmin(id) && selectedId == null)) &&
                                                <h6 style={{float:'right'}} >
                                                <span>
                                                  {" "}
                                                  {data.createdOn
                                                    .replace("T", " ")
                                                    .slice(0, -4)}{" "}
                                                </span>{" "}
                                              </h6>
                                              }
                                        </div>
                                      </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          )}

                          <div class="pager">
                            {table !== undefined &&
                              table !== null &&
                              table.length > 0 &&
                              search == "" && (
                                <p>
                                  {paginationDetails.currentPage !== undefined && paginationDetails.currentPage !== null  && paginationDetails.totalPost !== undefined && paginationDetails.totalPost !== null &&  table !== undefined && Array.isArray(table) && setpageContent(paginationDetails.currentPage - 1 , table.length, paginationDetails.totalPost)}
                                  <button
                                    class={
                                      isExportable
                                        ? "lbbtn"
                                        : "lbbtn-disable-btn"
                                    }
                                    disabled={!isExportable}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="First select the filter than you can export"
                                    type="button"
                                    onClick={onExportData}
                                  >
                                    Export
                                  </button>
                                </p>
                              )}

                            {
                              paginationDetails.totalPost !== undefined &&
                                paginationDetails.totalPost !== null &&
                                paginationDetails.totalPost > 10 &&
                                search == "" && (
                                  <Pagination
                                    className="pagination-bar"
                                    currentPage={paginationDetails.currentPage}
                                    totalCount={paginationDetails.totalPost}
                                    pageSize={paginationDetails.postsPerPage}
                                    onPageChange={(page) =>
                                      handalpageclick(page)
                                    }
                                  />
                                )
                              // <Pagination  postsPerPage={paginationDetails.postsPerPage} totalPosts={table.length} paginate={paginate} currentPage={paginationDetails.currentPage} />
                            }
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  <div
                    class="tab-pane fade"
                    id="mobi-grap"
                    role="tabpanel"
                    aria-labelledby="mobi-grap-tab"
                  >
                    {/* <TransactionGraph/>  */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

export default OTTRecharge;
